// Product card component - handles swatch switching and image updates

const ProductCard = class {
  constructor(element) {
    this.element = element;
    this.swatches = element.querySelectorAll('.product-card__swatch');
    const productId = element.dataset.productId;
    this.primaryImage = document.getElementById(`primary-image-${productId}`);
    this.secondaryImage = document.getElementById(
      `secondary-image-${productId}`
    );
    this._attachListeners();
  }

  _attachListeners() {
    this.swatches.forEach((s) =>
      s.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._handleSwatchClick(e);
      })
    );
  }

  _handleSwatchClick(evt) {
    // Remove hovered class when a swatch is clicked
    this.element.classList.remove('hovered');

    const clickedSwatch = evt.currentTarget;

    // Remove "active" class from all swatches and add it to the clicked one
    this.swatches.forEach((swatch) => swatch.classList.remove('active'));
    clickedSwatch.classList.add('active');

    // Update the primary and secondary images
    const newImage = clickedSwatch.getAttribute('data-image');
    this._updateImages(newImage);
  }

  _updateImages(imageUrl) {
    if (this.primaryImage) this.primaryImage.src = imageUrl;
    if (this.secondaryImage) this.secondaryImage.src = imageUrl;
  }
};

// Initialize product cards
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.product-card')
    .forEach((card) => new ProductCard(card));
});

export default ProductCard;
